<template>
  <div>
    <div v-if="loading">
      <p>De gegevens worden geladen</p>
    </div>

    <div v-else class="o-grid__item u-size-12 u-size-8@desktop u-align-center">
      <div class="o-wrapper o-wrapper--text">
        <div class="c-hero">
          <h1 class="c-hero__title">Resultaat</h1>
        </div>
      </div>

      <article class="c-article">
        <div class="c-article__content">
          <h2 class="tac">{{ groupname }}</h2>

          <div v-html="$store.state.data.resulttext" />

          <div>
            <!-- extra div to prevent duplicate index -->
            <div v-for="(type, index)  in $store.state.data.dimensions" :key="type.id">
              <p v-if="average[index] == Math.min(...average)" v-html="type.low" />
            </div>
          </div>
          <div>
            <!-- extra div to prevent duplicate index -->
            <div v-for="(type, index)  in $store.state.data.dimensions" :key="type.id">
              <p v-if="average[index] == Math.max(...average)" v-html="type.high" />
            </div>
          </div>
          <div class="b-button-group u-hide-print">
            <button
              class="b-button b-button--pill"
              onclick="window.print();return false;"
            >Print deze samenvatting</button>
          </div>

          <apexchart type="radar" height="900px" :options="chartOptions" :series="series" />
          <p
            v-if="members==1"
          >Je bent vooralsnog de enige deelnemer uit jouw gemeente. We mailen je een link waarmee je later opnieuw kunt kijken naar dit resultaat. Met deze link zie je dan ook nieuwe reacties.</p>
          <p v-if="members>1">Van jouw gemeente hebben {{members}} leden deelgenomen.</p>

          <!-- <div v-for="(type, index)  in $store.state.data.dimensions" v-bind:key="type.id">
            <h2>{{ type.name }}</h2>

            <p>Uw gemiddelde score: {{ average[index] }}</p>
            <div
              v-for="question in $store.state.data.questions.filter( x => x.dimension == type.id)"
              v-bind:key="question.id"
            >
              <h5>{{ question.question}}</h5>

              <p>Uw antwoord: {{ $store.state.value[question.id]}}</p>
            </div>
          </div>-->

          <VerderPraten />
        </div>
      </article>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import VerderPraten from "../components/VerderPraten.vue";
export default {
  modules: {},
  components: {
    VerderPraten
  },
  data() {
    return {
      members: 0,
      tokengroupname: false,
      loading: true,
      series: [
        {
          name: "Uw waarden",
          data: [0, 0, 0, 0, 0, 0]
        },
        {
          name: "Uw gemeente",
          data: [0, 0, 0, 0, 0, 0]
        },
        {
          name: "Gemiddeld landelijk",
          data: [0, 0, 0, 0, 0, 0]
        }
      ],
      average: [],
      chartOptions: {
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "20px"
          },
          background: {
            enabled: true,
            borderRadius: 2
          }
        },
        chart: {
          toolbar: {
            show: false
          },
          height: 350,
          type: "radar",
          dropShadow: {
            enabled: true,
            blur: 1,
            left: 1,
            top: 1
          }
        },
        stroke: {
          width: 0
        },
        fill: {
          opacity: 0.4
        },
        markers: {
          size: 4
        },
        yaxis: {
          show: false,
          max: 10
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: "20px"
            }
          }
        }
      }
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.reported = true;
      this.token = this.$route.params.id;
    }
    var params = {
      reported: this.reported
    };

    if (this.token) {
      params.token = this.token;
    } else {
      params.newsletter = this.$store.state.newsletter;
      params.group = this.$store.state.group;
      params.answers = this.$store.state.value;
    }
    params.email = this.$store.state.email;
    params.name = this.$store.state.name;

    var that = this;
    axios
      .post("https://kernwaarden.protestantsekerk.nl/report/", params)
      .then(response => {
        // handle success

        if (response.data.answers) {
          that.answers = response.data.answers;
          that.tokengroupname = response.data.group;
        }
        if (response.data.token) {
          that.token = response.data.token;
        }

        const filtered = this.$store.state.data.dimensions.map(x =>
          this.$store.state.data.questions
            .filter(y => y.dimension == x.id)
            .map(z => z.id)
        );
        const values = filtered.map(x =>
          x.map(y => this.$store.state.value[y])
        );
        const average = values.map(
          arr =>
            parseInt((arr.reduce((a, b) => a + b, 0) / arr.length) * 10) / 10
        );

        this.members = response.data.members;
        this.series[0].data = average;
        this.series[1].data = response.data.community;
        this.series[2].data = response.data.average;
        this.average = average;
        this.chartOptions.xaxis.categories = this.$store.state.data.dimensions.map(
          x => x.name
        );

        if (!this.reported) {
          this.reported = true;
        }
        this.loading = false;
      })
      .catch(function(error) {
        that.networkError = true;
        that.errorMessage = error;
      });
  },
  computed: {
    groupname: {
      get() {
        if (this.tokengroupname) {
          return this.tokengroupname;
        } else {
          return this.$store.state.group.name;
        }
      }
    },

    reported: {
      get() {
        return this.$store.state.reported;
      },
      set(newValue) {
        return this.$store.dispatch("setReported", newValue);
      }
    },
    token: {
      get() {
        return this.$store.state.token;
      },
      set(newValue) {
        return this.$store.dispatch("setToken", newValue);
      }
    },
    answers: {
      get() {
        return this.$store.state.value;
      },
      set(newValue) {
        return this.$store.dispatch("setValue", newValue);
      }
    }
  }
};
</script>